import { ethers } from 'ethers';
import { useEffect, useState } from 'react';
import React from "react";
import axios from 'axios';
import NFTCollection from './NFTCollection.json';
import { Card, Container, Text, Grid, Button, Image } from '@nextui-org/react';
import { nftContract, key, displayAmount, mainnet } from './settings';



async function refreshPage() {
  window.location.reload();
}

export default function NftPuller() {
  const [nfts, setNfts] = useState([])
  const [loadingState, setLoadingState] = useState('not-loaded')
  
  
  
  useEffect(() => {
    generateNft();
    }, [setNfts])
    

    async function generateNft() {
const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const signerAddress = await signer.getAddress();
      const wallet = new ethers.Wallet(key, provider);
      const contract = new ethers.Contract(nftContract, NFTCollection, signer);
      const itemArray = [];
      const nftArray = [];
      const nftsOwned = await contract.walletOfOwner(signerAddress);
      const baseuri = await contract.baseURI()
      
for (let i = 0; i < nftsOwned.length; i++){
  // console.log(nftsOwned[i])
let newUri = baseuri.slice(7)
// console.log(newUri)
let ipfs = "https://nftstorage.link/ipfs/"

  var imageNft =  nftsOwned[i]  ;
  // console.log(imageNft)
  
  nftArray.push(imageNft)
  // document.getElementById("cool").src = nftArr
 console.log(nftArray[i])}


      console.log(nftArray)
      contract.walletOfOwner(signerAddress).then(result => {
        // let totalSup = parseInt(result, 16)
  
        /*
        Replace "displayAmount" with "totalSup"
        below if you want to display all NFTs 
        in the collection BUT BE CAREFUL, it will render
        every nft image and possibly freeze your server/browser!!
        */
        for (let i = 0; i < result.length; i++) {


          var token = nftArray[i]                         
          const owner = signer
          const rawUri = contract.tokenURI(token)
          const Uri = Promise.resolve(rawUri)
          const getUri = Uri.then(value => {
            let str = value
            let cleanUri = str.replace('ipfs://', 'https://nftstorage.link/ipfs/')
            let metadata = axios.get(cleanUri).catch(function (error) {
              console.log(error.toJSON());
            });
            return metadata;
          })
          getUri.then(value => {
            let rawImg = value.data.image
            var name = value.data.name
            var rarity =[]
            var att = value.data.attributes[i]
           rarity.push(att)
           
           const listItems = rarity.map((value, i) => <li key={{value}}>{value.value}</li> )
           console.log(listItems)
            var desc = value.data.description
            let image = rawImg.replace('ipfs://', 'https://nftstorage.link/ipfs/')
            Promise.resolve(signer).then(value => {
              let ownerW = value;
              let meta = {
                name: name,
                img: image,
                list: listItems,
                wallet: ownerW,
                desc,
              }
              
              console.log(meta)
              itemArray.push(meta)

            })
          })
        }
      })
      await new Promise(r => setTimeout(r, 5000));
      setNfts(itemArray)
      setLoadingState('loaded');
    }

if (loadingState === 'loaded' && !nfts.length)
  
    return (
      <div >
        {
        nfts.map((nft, i) => {
          <div>
          <Card.Image src={nft.img} key={i}/>
        <h2>No Collections Retrieved</h2>
        </div>
})}
      </div>
    )
    return (
      <Container id='hmm-box1' md>
        <div id='hmmm-box'>
        <div id='hmm'>
          <Button id='refresh' onPress={refreshPage}>Refresh View</Button></div>
        <div id='hmm-text'>SafeOne Lifetime anti scam/rug insurance policy NFTs have a one time maximum claim of 500 U.S. dollars. There are no renewal maintenance, or hidden fees and each NFT is burned upon claim approval. Each NFT can be staked in our BUSD staking pool.</div>
      </div>
      <Grid.Container gap={3}>
        {nfts.map((nft, i) => {
            return (
              <Grid >
                <a>
                  <Card id='nftsCards' key={i} css={{  marginRight: '$1', boxShadow:'0px 2px 12px #000000' }} variant="bordered">
                    <Card.Image  src={nft.img} />
                    <Card.Body id="cardBody" md css={{background:"$gradient"}}>
                    <Text id='render' css={{color:'$white'}} h2>{nft.name}</Text>
                    <Text id='trait_type' css={{color:'$black'}} h2>Amount per Claim</Text>
                    <Text id='render' css={{color:'$white'}} h2>{nft.list}</Text>
                   
                    </Card.Body>
                  </Card>
                </a>
              </Grid>
            )
          })}
      </Grid.Container>
    </Container>
    )
}
